import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { supabase } from '../config/supabase';
import { ArrowLeft, Loader } from 'lucide-react';
import AvatarWardrobe from '../components/AvatarWardrobe';
import type { Avatar } from '../services/avatarService';
import './ProfilePage.css';

const AvatarsPage: React.FC = () => {
  const navigate = useNavigate();
  // /avatars?build=1 opens the free Avatar Builder straight away (profile, nudges).
  const [params] = useSearchParams();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    supabase.auth.getUser().then(({ data: { user } }) => {
      if (!user) {
        navigate('/');
        return;
      }
      setLoading(false);
    });
  }, [navigate]);

  const handleAvatarEquipped = (avatar: Avatar) => {
    // Sync to localStorage for in-world usage
    localStorage.setItem('eb-avatar-url', avatar.model_url);
    localStorage.setItem('eb-avatar-animations', JSON.stringify(avatar.animations || {}));
  };

  if (loading) {
    return (
      <div className="profile-loading">
        <Loader size={32} className="spinning" />
        <p>Loading avatars...</p>
      </div>
    );
  }

  return (
    <div className="profile-page">
      <header className="profile-header">
        <button className="profile-back-btn" onClick={() => navigate('/dashboard')}>
          <ArrowLeft size={18} /> Back to Dashboard
        </button>
        <h1>Avatars</h1>
        <span />
      </header>

      <div className="profile-content">
        <div className="profile-card avatar-card">
          <AvatarWardrobe
            onCreateNew={() => navigate('/avatars/new')}
            onAvatarEquipped={handleAvatarEquipped}
            openBuilder={params.get('build') === '1'}
          />
        </div>
      </div>

    </div>
  );
};

export default AvatarsPage;
